module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"addressNotCorrect":"Некорректный адрес","addressNotFound":"Указанный адрес не найден"}}')
  delete Component.options._Ctor
}
